var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Tag_svg__a)",
    fill: "#5C7AFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42.999 17.424-.39-14.092A2.972 2.972 0 0 0 39.723.445L25.63.055a2.95 2.95 0 0 0-2.182.87L.87 23.502a2.974 2.974 0 0 0 0 4.2l14.48 14.482a2.969 2.969 0 0 0 4.202 0L42.13 19.607c.574-.575.891-1.37.869-2.183Zm-2.93.122L17.492 40.123c-.005.006-.017.017-.04.017s-.034-.011-.04-.017l-14.48-14.48a.057.057 0 0 1 0-.08L25.507 2.985a.058.058 0 0 1 .042-.016l14.092.389c.03 0 .054.025.055.055l.389 14.092c0 .015-.006.03-.017.041Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.403 6.508a5.057 5.057 0 0 0 0 7.143 5.048 5.048 0 0 0 7.143 0 5.057 5.057 0 0 0 0-7.143 5.048 5.048 0 0 0-7.143 0Zm5.082 5.083a2.136 2.136 0 1 1-3.022-3.023 2.136 2.136 0 1 1 3.022 3.023Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Tag_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .055)",
    d: "M0 0h43v43H0z"
  })))));
};

export default SvgTag;